import { GetServerSidePropsContext, PreviewData } from 'next';
import { SSRConfig } from 'next-i18next';
import { ParsedUrlQuery } from 'querystring';

export function getTextByLangInServer(
  context: GetServerSidePropsContext<ParsedUrlQuery, PreviewData>,
  i18nConfig: SSRConfig,
  key: string,
  interpolationMap?: {
    [key: string]: string;
  }
) {
  try {
    const keyMap = i18nConfig._nextI18Next?.initialI18nStore[context.locale!]?.['common'];
    if (interpolationMap) {
      let template = keyMap[key];
      Object.keys(interpolationMap).forEach((key) => {
        template = template.replace(
          new RegExp(`\\{\\{\\s*${key}\\s*\\}\\}`, 'g'),
          interpolationMap[key]
        );
      });
      return template;
    } else return keyMap[key];
  } catch {
    return '';
  }
}
